import { createBrowserHistory } from "history";

const { gtag } = window;
/**
 * @function history
 * @desc This handles createBrowserHistory
 * createBrowserHistory method: This method creates a new history object
 * A history object to use for navigation.
 */
export const history = createBrowserHistory();

export const gTagEvent = () => {
  gtag("event", "conversion", {
    send_to: "AW-739843758/ZkkWCNOotqkBEK695OAC",
    transaction_id: ""
  });
};
